import { render, staticRenderFns } from "./RevenueShareOverview.vue?vue&type=template&id=1a369802&scoped=true"
import script from "./RevenueShareOverview.vue?vue&type=script&lang=js"
export * from "./RevenueShareOverview.vue?vue&type=script&lang=js"
import style0 from "./RevenueShareOverview.vue?vue&type=style&index=0&id=1a369802&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a369802",
  null
  
)

export default component.exports